import { supabase } from './supabase'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = (t: string): any => (supabase as any).from(t)

export function generateShareToken(): string {
  const arr = new Uint8Array(32)
  crypto.getRandomValues(arr)
  let bin = ''
  for (let i = 0; i < arr.length; i++) bin += String.fromCharCode(arr[i])
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function publicInvoiceUrl(token: string): string {
  return `${window.location.origin}/i/${token}`
}

export async function ensureShareToken(
  orderId: string,
  currentToken: string | null,
): Promise<string> {
  if (currentToken) return currentToken
  const token = generateShareToken()
  const { error } = await db('sales_orders')
    .update({ share_token: token })
    .eq('id', orderId)
  if (error) throw error
  return token
}

export async function rotateShareToken(orderId: string): Promise<string> {
  const token = generateShareToken()
  const { error } = await db('sales_orders')
    .update({ share_token: token })
    .eq('id', orderId)
  if (error) throw error
  return token
}
